// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTabbedPageView-PaddedVeloCard_cls1__eGjne","cls2":"VeloTabbedPageView-PaddedVeloCard_cls2__4pgb+ VeloTabbedPageView-PaddedVeloCard_cls1__eGjne"};